export class ContactLocalization {
    contactErrorMessage: string = 'Invalid contact format.';
    requiredErrorMessage: string = 'Contact required.';
    requiredEmailErrorMessage: string = 'Email required.';
    contactEmailErrorMessage: string = 'Invalid email format.';
    requiredPhoneErrorMessage: string = 'Phone required.';
    contactPhoneErrorMessage: string = 'Invalid phone format.';
    requiredMobileErrorMessage: string = 'Mobile required.';
    contactMobileErrorMessage: string = 'Invalid mobile format.';
    requiredNameErrorMessage: string = 'Name required.';
    contactNameErrorMessage: string = 'Invalid name format.';
    requiredTitleErrorMessage: string = 'Title required.';
    contactTitleErrorMessage: string = 'Invalid title format.';
    requiredAddressErrorMessage: string = 'Address required.';
    contactWebAddressErrorMessage: string = 'Invalid Web address format.';

    contactName: string = 'Name';
    contactAddress: string = 'Address';
    contactTitle: string = 'Title';
    contactPhone: string = 'Phone Number';
    contactMobile: string = 'Mobile';
    contactEmail: string = 'E-mail';
    contactWebAddress: string = 'Web Address';
    contactWork: string = 'Work: +';
    contactMobilelbl: string = 'Mobile: +';
    contactAddContact: string = 'Add Contact';
}
